// extracted by mini-css-extract-plugin
module.exports = {"root":"FloatingMenuButton_root__3EPff","shifted":"FloatingMenuButton_shifted__1Osp9","showCloseIcon":"FloatingMenuButton_showCloseIcon__3wpYJ"};